import { isRegexMatch } from 'helpers/core';
import { defineMessages } from 'react-intl';
import _isEmpty from 'lodash/isEmpty';

import { EMAIL_REGEX } from 'constants/logic';

const messages = defineMessages({
  requiredField: {
    id: 'staff-account.errors.required',
    defaultMessage: 'This field is required',
  },
  invalidEmail: {
    id: 'staff-account.errors.invalid-email',
    defaultMessage: 'Please enter a valid email address',
  },
  classPassEmail: {
    id: 'staff-account.errors.classpass-email',
    defaultMessage: 'Please enter a not ClassPass email',
  },
});

export const syncValidator = values => {
  const { firstName, lastName, email, venueIds } = values;

  const errors = {};
  if (!firstName || firstName.trim().length === 0) {
    errors.firstName = messages.requiredField;
  }

  if (!lastName || lastName.trim().length === 0) {
    errors.lastName = messages.requiredField;
  }

  if (!email) {
    errors.email = messages.requiredField;
  }

  if (email) {
    if (!isRegexMatch(email, EMAIL_REGEX)) {
      errors.email = messages.invalidEmail;
    }

    if (email.includes('@classpass.com')) {
      errors.email = messages.classPassEmail;
    }
  }

  if (_isEmpty(venueIds)) {
    errors.venueIds = messages.requiredField;
  }

  return errors;
};
